import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

export const useCategories = () => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['categories'],
    queryFn: () => productService.getCategories(),
    staleTime: 5 * 60 * 1000
  });

  return {
    categories: data ?? [],
    isLoading,
    error
  };
};
